import LocalStorage from 'quasar/src/plugins/LocalStorage.js';

export async function boot({ dispatch }) {
  // await dispatch('user/initializeUser', null, { root: true });
  await dispatch('location/fetchDeliveryMethods', null, { root: true });
  await dispatch('location/fetchPaymentMethods', null, { root: true });
  await dispatch('location/fetchLocations', null, { root: true });
  await dispatch('category/fetchCategories', null, { root: true });
}

export async function updateLanguage({ commit }, { language }) {
  commit('updateLanguage', { language });
}

export async function updateLanguageFromStorage({ dispatch }) {
  if (LocalStorage.has('language')) {
    dispatch('updateLanguage', { language: LocalStorage.getItem('language') });
  }
}
